import script from "./OpenTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./OpenTableWidget.vue?vue&type=style&index=0&id=14cecdc6&lang=scss"

const __exports__ = script;

export default __exports__